package Utils

open class StateNotifier {
    open fun advance() {

    }

    open fun finalize() {}
}